import { MenuItem } from "primereact/menuitem";
import { IWsRoutePath, wsRouteMatch } from "../../../url/WSRouter";
import { getCurrentPath } from "../../../url/getCurrentPath";
import { getRedirectProps } from "../../../url/redirect";
import { concatClassnames } from "../../../utils/util";

export interface CustomMenuItem extends MenuItem {
  path?: string;
  label?: string;
  icon?: string;
  className?: string;
  onClick?: (evt: any, menuItem?: CustomMenuItem) => Promise<void> | void;
  isSelected?: () => boolean;
  items?: CustomMenuItem[];

  template?: () => JSX.Element;
  href?: string;
  target?: string;
}

export interface CompletedMenuItem extends MenuItem {
  path?: string;
  label?: string;
  icon?: string;
  className?: string;
  isSelected?: () => boolean;
  command?: (evt: any) => void;
  items?: CompletedMenuItem[];
  template?: () => JSX.Element;
}

export const isPathSelected = (path: IWsRoutePath) =>
  wsRouteMatch(path, getCurrentPath());

export const completeMenuItem = (item: CustomMenuItem): CompletedMenuItem => {
  const isSelected = item.isSelected?.() ?? false;

  const mappedItem: CustomMenuItem = {
    label: item.label,
    icon: item.icon,
    className: isSelected
      ? concatClassnames([item.className, "active"])
      : concatClassnames([item.className]),
    items: item.items?.map((subItem) => completeMenuItem(subItem)),
    separator: item.separator,
    template: item.template,
    disabled: item.disabled,
  };

  if (item.onClick) {
    mappedItem.command = (evt) => {
      return item.onClick(evt, item);
    };
  } else if (item.path) {
    const { href, target, onClick } = getRedirectProps(item.path, {
      mergeQs: {},
    });

    mappedItem.command = (evt: any) => {
      return onClick(evt);
    };

    mappedItem.url = href;
    mappedItem.target = target;
  }

  if (item.target) mappedItem.target = item.target;
  if (item.href) mappedItem.url = item.href;

  return mappedItem;
};
